/**
 * /tracking/s2s-postback — operator page for feature #159 (S2S postback).
 *
 * Declares a TanStack Router route and renders the `S2sPostbackPage`
 * feature. Root wire-up picks this up from `router.tsx`.
 *
 * `?advertiserId=` deep-links the scope so operators can jump in from an
 * advertiser detail view.
 */

import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { S2sPostbackPage } from "@/features/s2s-postback/S2sPostbackPage";

interface TrackingS2sPostbackSearch {
	advertiserId?: string;
}

export const trackingS2sPostbackRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/tracking/s2s-postback",
	validateSearch: (
		raw: Record<string, unknown>,
	): TrackingS2sPostbackSearch => {
		const v = raw.advertiserId;
		if (typeof v === "string" && v.trim().length > 0) {
			return { advertiserId: v.trim() };
		}
		return {};
	},
	component: TrackingS2sPostbackRoute,
});

export default trackingS2sPostbackRoute;

export function TrackingS2sPostbackRoute() {
	const { advertiserId } = trackingS2sPostbackRoute.useSearch();

	return (
		<div className="flex flex-col">
			<nav
				aria-label="Breadcrumb"
				className="mx-auto w-full max-w-6xl px-6 pt-10 text-sm text-zinc-500 sm:pt-16"
			>
				<ol className="flex flex-wrap items-center gap-1">
					<li>
						<Link
							to="/"
							className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
						>
							Dashboard
						</Link>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li>
						<span className="rounded-[6px] px-1 py-0.5">Tracking</span>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li className="text-zinc-900">S2S postback</li>
				</ol>
			</nav>

			<S2sPostbackPage initialAdvertiserId={advertiserId} />
		</div>
	);
}

// Named export for the root wire-up cycle.
export { TrackingS2sPostbackRoute as TrackingS2sPostbackPage };
